import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Alert, Button, Modal } from '@storable/canaveral-components';
import styles from './styles.scss';

const propTypes = {
  onCancelDelete: PropTypes.func.isRequired,
  onConfirmDelete: PropTypes.func.isRequired,
  domain: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
  submitErrors: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.number.isRequired,
      message: PropTypes.string.isRequired,
    }).isRequired,
  ),
  successMessage: PropTypes.string,
};

const defaultProps = {
  submitErrors: [],
  submitting: false,
  successMessage: undefined,
};

const HostnameCertSettingsDomainDeleteModal = ({
  domain,
  onCancelDelete,
  onConfirmDelete,
  submitErrors,
  submitting,
  successMessage,
}) => (
  <Modal
    aria-labelledby="delete-domain-modal"
    onDismiss={onCancelDelete}
    show
  >
    <Modal.Header>
      <Modal.Title>Are you sure you want to delete this domain?</Modal.Title>
    </Modal.Header>
    <Modal.Body className={styles.message}>
      {successMessage && (
        <Alert context="success">
          {successMessage}
        </Alert>
      )}
      {!submitting && submitErrors.length > 0 && (
        <Alert context="danger">
          {submitErrors.map(err => (
            <span key={err.code}>
              {err.message}&nbsp;
            </span>
          ))}
        </Alert>
      )}
      <span>
        Deleting this domain will delete all stored domain and SSL data for {domain}.
        This should only be done for customers who are no longer using this domain.
      </span>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onCancelDelete} disabled={submitting}>
        {successMessage ? 'Close' : 'Cancel'}
      </Button>
      <Button
        context="danger"
        disabled={submitting || !!successMessage}
        onClick={onConfirmDelete}
      >
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

HostnameCertSettingsDomainDeleteModal.propTypes = propTypes;
HostnameCertSettingsDomainDeleteModal.defaultProps = defaultProps;

HostnameCertSettingsDomainDeleteModal.fragments = {
  userError: gql`
    fragment HostnameCertSettingsDomainDeleteModalUserError on UserError {
      code
      message
    }
  `,
};

export default HostnameCertSettingsDomainDeleteModal;
